const EmptyState = () => {
  return (
    <div className="empty-state">
      <img
        src="/images/travolta.gif"
        alt="No media found"
        style={{ maxWidth: "300px", margin: "0 auto", display: "block" }}
      />
    </div>
  );
};

export default EmptyState;